import { parseClientConfig, type ClientConfig } from '@ferro/config';

// Animal Lovers App brand identity — the locked ALA design system
// (terracotta / sage / Fraunces), NOT the IAID parent-agency palette this
// tenant was forked into on 2026-04-13. Re-skinned 2026-06-30 to match the
// design lock in ~/memory/projects/animalloversapp.md + the live marketing
// site (animalloversapp.com). Do NOT revert to copper/slate/Cormorant —
// that is the IAID agency brand, a different brand.
const config: ClientConfig = parseClientConfig({
  id: 'animal-lovers',
  brand: {
    name: 'Animal Lovers App',
    tagline: 'Book daycare, boarding, and grooming for your pup — all in one place.',
    colors: {
      primary: '#D4764E',
      secondary: '#6B9E78',
      accent: '#F5C65D',
      text: '#2D3436',
      background: '#FDFBF7',
    },
    fonts: {
      heading: 'Fraunces',
      body: 'Plus Jakarta Sans',
    },
    logo: '/assets/logo.svg',
  },
  vertical: 'pet-services',
  // Only modules implemented under packages/core/modules/ are listed here.
  // Deferred capabilities (removed 2026-04-21, workstream wa-3.1):
  //   - 'ai-chat'     [DEFERRED] see docs/MODULE-ACTIVATION-DESIGN-2026-04-21.md
  //   - 'ai-monitor'  [DEFERRED] see docs/MODULE-ACTIVATION-DESIGN-2026-04-21.md
  //   - 'staff-mgmt'  [DEFERRED] staff-scheduling promoted to a real
  //                   module (#137); broader staff-mgmt still deferred
  modules: [
    'agreements',
    'auth',
    'booking',
    'crm',
    'loyalty',
    'messaging',
    'notifications',
    'payments',
  ],
  business: {
    services: ['daycare', 'boarding', 'grooming'],
    pricing: {
      daycare: 4500,
      boarding: 6500,
      grooming: 8500,
    },
    locations: [
      { name: 'Main', address: 'Mountain View, CA' },
    ],
    referralPrefix: 'AL',
  },
  loyalty: {
    earnRate: 1,
    serviceMultipliers: { grooming: 1.5 },
    redemptionTiers: { '100': 1000, '250': 2500, '500': 5000 },
  },
  deployment: {
    // Railway-hosted ALA platform server. CNAME `api.animalloversapp.com` →
    // `4ey98nqa.up.railway.app` (added 2026-04-28; SSL provisioning).
    apiUrl: 'https://animalloversapp-platform-api-production.up.railway.app',
    // Customer + admin apps run locally during dogfood (Vite dev servers).
    // Public Vercel deploy is a follow-up task (GitHub-connect monorepo).
    customerAppUrl: 'http://localhost:5173',
    adminAppUrl: 'http://localhost:5174',
  },
  integrations: {
    // Deployment-level Stripe mode. R23 (2026-10-05): the CUSTOMER checkout no
    // longer reads this — each tenant's own online payments mode decides
    // (packages/core/tenant/get-tenant-online-payments.ts; unset ⇒ 'off', and
    // 'simulation' only for a tenant marked demo). Still read by the bare
    // payments composition (tests/tools), the desk (payments-admin) and the
    // Stripe Connect onboarding route.
    stripe: { mode: 'simulation' },
    openai: { model: 'gpt-4o' },
    pos: null,
  },
});

export default config;
